import './style.scss';

import React from 'react';

function LoadingSpinner(props) {
  const className =
    'loading-spinner' +
    (props.green ? ' loading-spinner--green' : '') +
    (props.black ? ' loading-spinner--black' : '');
  return props.inline ? (
    <div className={className}>Loading...</div>
  ) : (
    <div className="loading-spinner-container">
      <div className="loading-spinner-inner-container">
        <div className={className}>Loading...</div>
      </div>
    </div>
  );
}

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./shared/components/ui/loadingSpinner/index.js